/**
 * After login we want to add url hash part to form action
 */
(function ($) {
	let hash = unescape(self.document.location.hash);
	let loginForm = $('#login-form');

	if (loginForm.length === 0 || hash.length === 0) {
		return;
	}

	let action = loginForm.attr('action');
	loginForm.attr('action', action + hash);
})(jQuery);
